
define('template!webshopAttributesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="tabs">\n    <div class="tab ';
 if (tab === 'matching') { ;
__p += 'active';
 } ;
__p += '" data-tab="matching">' +
((__t = ( _.i18n('attributeMatching.tabs.matching', null, 'Attributes & matching') )) == null ? '' : __t) +
'</div>\n    <div class="tab ';
 if (tab === 'category') { ;
__p += 'active';
 } ;
__p += '" data-tab="category">' +
((__t = ( _.i18n('attributeMatching.tabs.category', null, 'Products by category') )) == null ? '' : __t) +
'</div>\n    <div class="tab ';
 if (tab === 'grid') { ;
__p += 'active';
 } ;
__p += '" data-tab="grid">' +
((__t = ( _.i18n('attributeMatching.tabs.grid', null, 'Category grid') )) == null ? '' : __t) +
'</div>\n    <div class="tab ';
 if (tab === 'filters') { ;
__p += 'active';
 } ;
__p += '" data-tab="filters">' +
((__t = ( _.i18n('attributeMatching.tabs.categoryFilters', null, 'Category filters') )) == null ? '' : __t) +
'</div>\n</div>\n<div class="content-region"></div>\n';

}
return __p
};});

